import { c as _c } from "react/compiler-runtime";
import type { NextRouter } from 'next/router';
import { useRouter } from 'next/router';
import { createContext, type JSX } from 'react';
import * as React from 'react';
export const RouterContext = createContext<NextRouter | null>(null);
export function RouterProvider(props) {
  const $ = _c(3);
  const {
    children
  } = props;
  const router = useRouter();
  let t0;
  if ($[0] !== children || $[1] !== router) {
    t0 = <RouterContext.Provider value={router}>{children}</RouterContext.Provider>;
    $[0] = children;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}